// extracted by mini-css-extract-plugin
export default {"root":"PaidMessageChargePane-module__root","message":"PaidMessageChargePane-module__message","messageStars":"PaidMessageChargePane-module__messageStars"};